import React, { useState, useEffect, useContext } from "react";
import { Modal, Select, Input, Avatar, message } from "antd";
import axios from "axios";
import { API_DOMAIN } from "../constants";
import { AuthContext } from "../contexts/AuthContext";
import { _fetchSRMUsers, getAgentColor, agentInitials } from "./helpers";

export function ReassignModal({ open, queryPk, onClose, onSuccess }) {
  const { authState } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [toUserId, setToUserId] = useState(null);
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    _fetchSRMUsers().then(setUsers);
  }, [open]);

  const handleClose = () => {
    setToUserId(null);
    setReason("");
    onClose();
  };

  const handleSubmit = async () => {
    if (!toUserId) { message.warning("Please select a user"); return; }
    if (!reason.trim()) { message.warning("Reason is required"); return; }
    setSaving(true);
    try {
      const res = await axios.post(
        `${API_DOMAIN}/queries/${queryPk}/reassign`,
        { to_user_id: toUserId, reason: reason.trim(), userId: authState?.id },
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      if (!res.data?.success) throw new Error(res.data?.message);
      message.success("Task reassigned");
      onSuccess?.();
      handleClose();
    } catch (e) {
      message.error(e?.response?.data?.message || e.message || "Reassign failed");
    } finally { setSaving(false); }
  };

  return (
    <Modal
      open={open}
      title="Reassign Task"
      onCancel={handleClose}
      onOk={handleSubmit}
      confirmLoading={saving}
      okText="Reassign"
      destroyOnClose
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 14, marginTop: 16 }}>
        <div>
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6, color: "#595959" }}>Assign To</div>
          <Select
            showSearch
            placeholder="Search users..."
            style={{ width: "100%" }}
            value={toUserId}
            onChange={setToUserId}
            filterOption={(input, opt) => (opt?.label ?? "").toLowerCase().includes(input.toLowerCase())}
            options={users.map(u => ({ value: u.id, label: u.fullName }))}
            optionRender={(opt) => (
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Avatar size={22} style={{ backgroundColor: getAgentColor(opt.label), fontSize: 9, flexShrink: 0 }}>
                  {agentInitials(opt.label)}
                </Avatar>
                {opt.label}
              </div>
            )}
          />
        </div>
        <div>
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6, color: "#595959" }}>
            Reason <span style={{ color: "#ff4d4f" }}>*</span>
          </div>
          <Input.TextArea
            rows={3}
            placeholder="e.g. Sales agent is on leave"
            value={reason}
            onChange={e => setReason(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
}
